module.exports = "/packs/images/facilities~f08d92d14046944262473bcb438a1546.svg";